module.exports = __webpack_public_path__ + "img/Equipment.e8012a88.svg";